// Vulnerability: the routes and the sidebar rows of `wealth.onboarding.vulnerability` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const VulnerabilityReviewsCard = lazy(() =>
    import('./vulnerability.slots').then((m) => ({ default: m.VulnerabilityReviewsCard })),
);

export default defineWebFeature({
    id: 'wealth.onboarding.vulnerability',
    routes: [
        {
            frontend: 'desk',
            path: 'vulnerability',
            lazy: () => import('@/pages/desk/vulnerability/page'),
        },
        {
            frontend: 'desk',
            path: 'suitability/vulnerability/:clientId',
            lazy: () => import('@/pages/desk/suitability/vulnerability/page'),
        },
        {
            frontend: 'comply',
            path: 'vulnerability',
            lazy: () => import('@/pages/comply/vulnerability/page'),
        },
        {
            frontend: 'comply',
            path: 'vulnerabilities',
            lazy: () => import('@/pages/comply/vulnerabilities/page'),
        },
        {
            frontend: 'comply',
            path: 'vulnerability/client/:clientId',
            lazy: () => import('@/pages/comply/vulnerability/client/page'),
        },
        {
            frontend: 'comply',
            path: 'vulnerability/evidence-library',
            lazy: () => import('@/pages/comply/vulnerability/evidence-library/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'vulnerability',
            label: 'Vulnerability',
            href: '/comply/vulnerability',
            icon: 'Heart',
            group: 'consumer-duty',
            order: 250,
            wip: true,
        },
        {
            // The Desk register of vulnerable clients, firm-wide and read-only.
            frontend: 'comply',
            key: 'vulnerabilities',
            label: 'Vulnerabilities',
            href: '/comply/vulnerabilities',
            icon: 'Heart',
            group: 'consumer-duty',
            order: 255,
        },
        {
            frontend: 'desk',
            key: 'desk-vulnerability',
            label: 'Vulnerable Clients',
            href: '/desk/vulnerability',
            icon: 'Heart',
            group: 'advice-suitability',
            order: 450,
        },
    ],
    slots: {
        'client.detail.attention': [
            {
                key: 'vulnerable',
                order: 20,
                select: (_input, ctx) => {
                    const { identity } = ctx.detail;
                    if (!identity.vulnerable) return null;
                    return {
                        key: 'vulnerable',
                        label: 'Vulnerable client',
                        tone: 'warning',
                        to:
                            ctx.view === 'desk'
                                ? `/desk/suitability/vulnerability/${identity.clientId}`
                                : ctx.view === 'comply'
                                  ? `/comply/vulnerability/client/${identity.clientId}`
                                  : undefined,
                    };
                },
            },
        ],
        'desk.dashboard.cards': [
            {
                key: 'vulnerability-reviews',
                order: 50,
                span: 6,
                rows: 2,
                title: 'Vulnerability reviews',
                summary: 'The vulnerability assessments of your book that fall due for review.',
                href: '/desk/vulnerability',
                countLabel: (n) => `${n} due`,
                emptyBehaviour: 'collapse',
                count: (ctx) =>
                    ctx.overview
                        ? (ctx.overview.vulnerabilityReviews ?? []).filter((r) =>
                              ctx.keepClient(r.clientId),
                          ).length
                        : null,
                Component: VulnerabilityReviewsCard,
            },
        ],
    },
});
